<div [class.active]="isOpen" class="title">{{title}}</div>
<ng-select #ngSelectControl [items]="items" [multiple]="true" [closeOnSelect]="false" [searchable]="false"
  bindLabel="{{bindLabel}}" bindValue="{{bindValue}}" placeholder="{{ placeholder | i18next }}" [selectableGroup]="true"
  [selectableGroupAsModel]="false" [(ngModel)]="model" (ngModelChange)="modelChange.emit(model)" (open)="isOpen=true;"
  (close)="isOpen=false;isFiltered=false" dropdownPosition="bottom" [searchFn]="customSearchFn" (search)="onSearch($event)">
  <ng-template ng-header-tmp let-item$="item$" let-items$="items$">
    <div class="filter">
      <span>{{ 'Filter' | i18next }}</span><input type="text" (input)="ngSelectControl.filter($event.target.value)"
        placeholder="{{'dashboard:Enter keyword' | i18next }}" />
    </div>
    <div class="header-items">
    <span class="item disabled" *ngIf="restrictedItems?.length">
        <span>{{'dashboard:Restricted fields selected'| i18next}}</span>
        <span><i class="far fa-times-circle" ></i></span>
    </span>
    <ng-container *ngFor="let id of model">
       <span class="item" *ngIf="itemExists(id)">
        <span *ngIf="translateItems">{{'dashboard:'+ itemText(id)| i18next}}</span>
        <span *ngIf="!translateItems">{{itemText(id)}}</span>
        <span><i class="far fa-times-circle" [class.disabled]="isItemDisabled(id)" (click)="clearItem(ngSelectControl,id)"></i></span>
      </span>
    </ng-container>
    </div>
    <label for="selectAll" (click)="selectAll(ngSelectControl)" *ngIf="!isFiltered || filteredItems?.length>0">
      <div class="checkbox" [class.checked]="isFiltered? isAllFilteredItemsSelected : (items?.length+restrictedItems?.length)==model?.length">
        <i class="fas fa-check" [class.hidden]="isFiltered? !isAllFilteredItemsSelected :(items?.length+restrictedItems?.length)!=model?.length"></i>
      </div>
      <ng-container *ngIf="!isFiltered && (items?.length+restrictedItems?.length)==model?.length">{{ 'Deselect all' | i18next }}</ng-container>
      <ng-container *ngIf="!isFiltered && (items?.length+restrictedItems?.length)!=model?.length">{{ 'Select all' | i18next }}</ng-container>
      <ng-container *ngIf="isFiltered && isAllFilteredItemsSelected">{{ 'Deselect all filtered' | i18next }}</ng-container>
      <ng-container *ngIf="isFiltered && !isAllFilteredItemsSelected">{{ 'Select all filtered' | i18next }}</ng-container>
    </label>
  </ng-template>
  <ng-template ng-multi-label-tmp let-items="items" let-items$="items$" let-index="index" let-clear="clear">
    <div class="ng-select-selected-items">
      <div class="all-items" *ngIf="model?.length>(3+keyCount) || restrictedItems?.length">
        <span *ngIf="model?.length>(3+keyCount)" class="dots">...</span>
        <span *ngIf="restrictedItems?.length" class="restricted" title="{{'Restricted access. You don’t have a permission to view some of the items.'| i18next}}">
          <i class="fal fa-eye-slash"></i>
        </span>
        <span *ngIf="model?.length>(3+keyCount)" class="count">{{model?.length-keyCount}}</span>
      </div>
      <ng-container  *ngFor="let item of items">
        <span class="item" *ngIf="itemExists(item[ngSelectControl.bindValue]) && !item.isKey">
          <span *ngIf="translateItems">{{'dashboard:'+ item[ngSelectControl.bindLabel]| i18next}}</span>
          <span *ngIf="!translateItems">{{item[ngSelectControl.bindLabel]}}</span>
          <span><i class="far fa-times-circle" [class.disabled]="item.disabled" (click)="removeItem(clear,item)"></i></span>
        </span>
      </ng-container>
    </div>
  </ng-template>
  <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
    <div class="checkbox" [class.checked]="item$.selected" [class.disabled]="item$.disabled">
      <i class="fas fa-check" [class.hidden]="!item$.selected"></i>
    </div>
    <ng-container *ngIf="translateItems">{{'dashboard:'+item[ngSelectControl.bindLabel]| i18next}}</ng-container>
    <ng-container *ngIf="!translateItems">{{item[ngSelectControl.bindLabel]}}</ng-container>
  </ng-template>
</ng-select>
